export default class RequestExternalAppCardTemplates {
  constructor(context) {
    this.context = context;
  }

  run() {
    // Have we already requested the data? If yes, then don't re-request
    if (this.context.stores.externalAppCardTemplates.isLoading()) {
      return;
    }

    this.context.stores.externalAppCardTemplates.clearErrorForLoading();
    this.context.gateways.externalAppCardTemplates.request();
    this.context.stores.externalAppCardTemplates.setLoading();
  }
}
